import { type OpportunityReport } from "@entities";
import { Stack } from "@mui/material";
import type { FC } from "react";
import type { CustomCell } from "../../../pages/tables/users-table/volunteers/components/types";

const HasPerformed: FC<CustomCell<OpportunityReport>> = ({ row }) => {
  return (
    <Stack flexDirection="row" alignItems="center">
      <img
        src={`/${row.original.isGoalAchieved ? "green-shield" : "red-shield"}.svg`}
        alt={row.original.isGoalAchieved ? "יעד הושג" : "יעד לא הושג"}
      />
    </Stack>
  );
};

export default HasPerformed;
